module.exports = __webpack_public_path__ + "img/20_15.66688f0b.png";